import { render, staticRenderFns } from "./HistoryEmpty.vue?vue&type=template&id=477d7225&"
import script from "./HistoryEmpty.vue?vue&type=script&lang=js&"
export * from "./HistoryEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports